/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetTradingChallengeByIDOptions,
  GetTradingChallengeByIDResponses,
} from '../types/GetTradingChallengeByID'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Fetch one trading challenge. COMPETITION_MANAGER can access only assigned challenge IDs.
 * @summary Get trading challenge by ID
 * {@link /v1/trading_challenges/:trading_challenge_id}
 */
export function getTradingChallengeByID<ThrowOnError extends boolean = true>(
  options: Options<GetTradingChallengeByIDOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetTradingChallengeByIDResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/trading_challenges/{trading_challenge_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetTradingChallengeByIDResponses, ThrowOnError>>,
  )
}
